export type EmojiCategory = {
  id: string;
  label: string;
  icon: string;
  emojis: string[];
};

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'smileys',
    label: 'Visages',
    icon: '😀',
    emojis: [
      '😀', '😁', '😂', '🤣', '😊', '🙂', '😉', '😍', '🥰', '😘', '😋', '😜', '🤪', '🤗', '🤔', '🫡',
      '😐', '😑', '😶', '🙄', '😏', '😒', '😬', '😮', '😯', '😲', '😳', '🥺', '😢', '😭', '😤', '😡',
    ],
  },
  {
    id: 'gestures',
    label: 'Gestes',
    icon: '👍',
    emojis: [
      '👍', '👎', '👏', '🙌', '🤝', '🙏', '💪', '✌️', '🤞', '🤙', '👋', '🫶', '👌', '🤌', '✋', '🖐️',
      '☝️', '👆', '👇', '👈', '👉', '🤷', '🤦', '🙋', '🙆', '🙅', '💁', '🧑‍💻', '🧑‍⚕️', '🧑‍🍳', '🧑‍🔧',
    ],
  },
  {
    id: 'hearts',
    label: 'Coeurs',
    icon: '❤️',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❤️‍🔥', '❤️‍🩹', '💕', '💞', '💓', '💗',
      '💖', '💘', '💝', '💟', '✨', '⭐', '🌟', '💫', '🔥', '💯', '✅', '❌', '⚠️', '❓', '❗', '💬',
    ],
  },
  {
    id: 'objects',
    label: 'Objets',
    icon: '📎',
    emojis: [
      '📎', '📌', '📷', '📱', '💻', '🖥️', '📦', '🛒', '💊', '🏥', '🚚', '📅', '⏰', '📝', '📊', '📈',
      '🎉', '🎁', '🏆', '☕', '🍕', '🥐', '🌿', '🌸', '🌞', '🌙', '☔', '❄️', '🚀', '✈️', '🏠', '🛍️',
    ],
  },
];
